import {
  GridItem,
  Link,
  SelectInputField,
  Text,
  TextInputField,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { css } from "@emotion/css";
import { Field, useField } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { Item } from "react-stately";

type PreviousNameProps = {
  index: number;
  field: components["schemas"]["NameCheckField"];
  onDelete: () => void;
};

export function PreviousName({ index, field, onDelete }: PreviousNameProps) {
  const { t } = useTranslation();
  const typeField = useField(`${field.name}[${index}].type`)[0];

  return (
    <>
      <GridItem
        className={css({
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        })}
      >
        <Text style="form/section-heading">
          {t("Previous name")} {index}
        </Text>

        <Link
          textStyle="global/body-secondary"
          textColor="text-weak"
          onPress={onDelete}
          testID={`personal-info-previous-name-${index}-delete-button`}
        >
          <Trans>Delete</Trans>
        </Link>
      </GridItem>

      <GridItem>
        <Field
          name={`${field.name}[${index}].type`}
          label={t("Name type")}
          as={SelectInputField}
          placeholder={t("Please select")}
          isRequired
          testID={`personal-info-previous-name-${index}-selector`}
        >
          <Item key="FORMER">{t("Previous name")}</Item>
          <Item key="MAIDEN">{t("Maiden name")}</Item>
          <Item key="ALIAS">{t("Alias")}</Item>
        </Field>
      </GridItem>

      {["FORMER", "ALIAS"].find((t) => t === typeField.value) && (
        <GridItem>
          <Field
            as={TextInputField}
            label={t("Alias")}
            name={`${field.name}[${index}].first_name`}
            isRequired
            testID={`personal-info-previous-name-${index}-alias-input`}
          />
        </GridItem>
      )}

      {["FORMER", "MAIDEN"].find((t) => t === typeField.value) && (
        <GridItem>
          <Field
            as={TextInputField}
            label={t("Legal last name")}
            name={`${field.name}[${index}].last_name`}
            isRequired
            testID={`personal-info-previous-name-${index}-last-name-input`}
          />
        </GridItem>
      )}
    </>
  );
}
